import { Button, Flex } from "@chakra-ui/react";
import { TextFieldGroup } from "../../fields/TextFieldGroup";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLoginMutation } from "../../../hooks/useAuthMutations";
import { FunnelOnSuccess } from "../../funnel/types";

export function LoginForm({
  onSuccess,
  invalidate,
  loading,
  loadingText,
  autoFocus = true,
}: {
  onSuccess: FunnelOnSuccess;
  invalidate?: boolean;
  loading?: boolean;
  loadingText?: string;
  autoFocus?: boolean;
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailIsValid, setEmailIsValid] = useState(true);
  const { t } = useTranslation();

  const { mutate, isPending } = useLoginMutation({
    invalidate,
    onSuccess,
  });

  const handleLoginClick = async () => {
    if (!email || !password) {
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    setEmailIsValid(isValidEmail);

    if (isValidEmail) {
      mutate({ email, password });
    }
  };

  return (
    <Flex
      direction="column"
      // pb="24px"
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          handleLoginClick();
        }
      }}
    >
      <TextFieldGroup
        textFields={[
          {
            id: "inputLoginEmail",
            type: "email",
            placeholder: t("components.auth.email"),
            onChange: (value) => setEmail(value),
            error: emailIsValid
              ? undefined
              : t("components.auth.invalidEmailFormat"),
            autoFocus,
          },
          {
            id: "inputLoginPassword",
            type: "password",
            placeholder: t("components.auth.password"),
            onChange: (value) => setPassword(value),
          },
        ]}
      />
      <Button
        id="btnLoginSubmit"
        variant="primary"
        size="lg"
        type="submit"
        mt="24px"
        width={"full"}
        onClick={handleLoginClick}
        isLoading={loading || isPending}
        loadingText={loadingText}
      >
        {t("components.auth.login")}
      </Button>
    </Flex>
  );
}
